import * as React from 'react';

// Utils
import { selectors } from '@src/shared/src';
import { useSelector } from 'react-redux';

// Constants
// Actions
// Models
import { HotelModel, RentalModel } from '@src/shared/src/models';

// Interfaces
import { IRootState } from '@src/store';

// Components
import ConfirmedTrip from './ConfirmedBooking/ConfirmedTrip';
import HotelBooking from './ConfirmedBooking/ConfirmedHotel';
import RentalBooking from './ConfirmedBooking/ConfirmedRental';

const CheckoutConfirmBookedItems: React.FC = () => {
  const basketItems = useSelector((state: IRootState) =>
    selectors.checkout.basketItems(state.checkout),
  );
  const basketStatus = useSelector((state: IRootState) => selectors.checkout.basketStatus(state));

  const outwardTrip = useSelector((state: IRootState) =>
    selectors.checkout.outwardTrip(state.checkout),
  );

  const inboundTrip = useSelector((state: IRootState) =>
    selectors.checkout.inboundTrip(state.checkout),
  );

  const bookingHotels = useSelector((state: IRootState) => state.checkout.hotels);
  const bookingRentals = useSelector((state: IRootState) => state.checkout.rentals);

  return (
    <>
      {outwardTrip && <ConfirmedTrip trip={outwardTrip} basketItems={basketItems} basketStatus={basketStatus} />}
      {inboundTrip && <ConfirmedTrip trip={inboundTrip} basketItems={basketItems} basketStatus={basketStatus} />}
      {bookingHotels.map((hotel: HotelModel) => (
        <HotelBooking key={`hotel-${hotel.id}`} hotel={hotel} basketItems={basketItems} basketStatus={basketStatus} />
      ))}
      {bookingRentals.map((rental: RentalModel) => (
        <RentalBooking key={`rental-${rental.id}`} rental={rental} basketItems={basketItems} basketStatus={basketStatus} />
      ))}
    </>
  );
};

export default CheckoutConfirmBookedItems;
